import React, { memo } from "react";
import Icon, { IconNames } from "../../../../core/components/Icon.tsx";

const DropdownSectionCombined = ({
    titleSection1,
    children1,
    icon1,
    titleSection2,
    children2,
    icon2,
    titleSection3,
    children3,
    icon3,
    titleSection4,
    children4,
    icon4,
}: {
    titleSection1: string;
    children1: React.ReactNode;
    icon1: IconNames;
    titleSection2: string;
    children2: React.ReactNode;
    icon2: IconNames;
    titleSection3?: string;
    children3?: React.ReactNode;
    icon3?: IconNames;
    titleSection4?: string;
    children4?: React.ReactNode;
    icon4?: IconNames;
}) => {
    return (
        <div className="dropdown-content-combined">
            <div className="dropdown-content-2">
                <div className="titulo-navbar-icone">
                    <Icon name={icon1} size="xl" theme="dark" />
                    <span className="titulo-navbar-texto">{titleSection1}</span>
                </div>
                {children1}
            </div>
            <div className="dropdown-content-2">
                <div className="titulo-navbar-icone">
                    <Icon name={icon2} size="xl" theme="dark" />
                    <span className="titulo-navbar-texto">{titleSection2}</span>
                </div>
                {children2}
            </div>
            {children3 && icon3 && titleSection3 && (
                <div className="dropdown-content-2">
                    <div className="titulo-navbar-icone">
                        <Icon name={icon3} size="xl" theme="dark" />
                        <span className="titulo-navbar-texto">{titleSection3}</span>
                    </div>
                    {children3}
                </div>
            )}
            {children4 && icon4 && titleSection4 && (
                <div className="dropdown-content-2">
                    <div className="titulo-navbar-icone">
                        <Icon name={icon4} size="xl" theme="dark" />
                        <span className="titulo-navbar-texto">{titleSection4}</span>
                    </div>
                    {children4}
                </div>
            )}
        </div>
    );
};

export default memo(DropdownSectionCombined);
